import { render, staticRenderFns } from "./EmiratesFilter.vue?vue&type=template&id=dae12b5c&scoped=true&"
import script from "./EmiratesFilter.vue?vue&type=script&setup=true&lang=ts&"
export * from "./EmiratesFilter.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./EmiratesFilter.vue?vue&type=style&index=0&id=dae12b5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae12b5c",
  null
  
)

export default component.exports